// tslint:disable: completed-docs
import {
    APP,
    CONTAINER_TARIFF,
} from 'Constant';

export const SET_DEFAULT_STATE = `${APP}/${CONTAINER_TARIFF}/SET_DEFAULT_STATE`;

// Regex
export const REGEX_ONETIMEFEE = /([0-9]+,[0-9]{2})(?=\s(?:€|&euro;))/;
export const REGEX_STAIRWAY_MONTH = /([0-9]+)(?=\. Monat)/;
export const REGEX_STAIRWAY_PRICE = /([0-9]+,[0-9]{2})(?=\s(?:€|&euro;))/;
